<template>
  <div class="container">
    <div class="title">
      <span>项目</span>
      <span class="back" @click="back">
        <i class="iconfont icon-fanhui"></i> 返回
      </span>
    </div>
    <div class="wrap">
      <el-row>
        <el-col
          :lg="16"
          :md="20"
          :sm="24"
          :xs="24">
          <el-form
            v-loading="loading"
            :model="form"
            :rules="rules"
            status-icon
            ref="form"
            label-width="100px"
            @submit.native.prevent>
            <el-form-item label="名称" prop="title">
              <el-input size="medium" v-model="form.title" placeholder="请填合作商名称"></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="url">
              <el-input size="medium" v-model="form.url" autosize placeholder="请填写项目地址"></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="summary">
              <el-input size="medium" v-model="form.summary" autosize placeholder="请填写简介"></el-input>
            </el-form-item>
            <el-form-item label="图标" prop="logo">              
              <uploader ref="logoUploader" v-model="form.logo"/>
            </el-form-item>  
            <el-form-item label="访客基数" prop="logo">              
              <el-input size="medium" v-model="form.view_count" autosize placeholder="设置访客基数"></el-input>
            </el-form-item>  
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否发布" prop="published">
                  <el-switch v-model="form.published"></el-switch>
                </el-form-item>  
              </el-col> 
              <el-col :span="12">
                <el-form-item label="审核订阅者" prop="need_verify">
                  <el-switch v-model="svr_config.need_verify"></el-switch>
                </el-form-item>  
              </el-col>
              <el-col> 
                <el-row>         
                  <el-col :span="8">      
                    <el-form-item label="访客ID基数" prop="user_base_id">  
                          <el-input-number size="medium" v-model="svr_config.user_base_id" autosize></el-input-number>                    
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">      
                    <el-form-item label="访客ID增量" prop="user_id_skip">  
                          <el-input-number size="medium" v-model="svr_config.user_id_skip" autosize></el-input-number>                    
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>  

            <el-row>              
              <el-col :span="4">
                <el-form-item label="显示抽奖" >                  
                  <el-switch v-model="config.tool.show_lottery"></el-switch>                
                </el-form-item> 
              </el-col>
              <el-col :span="4">
                <el-form-item label="奖品核销" >  
                  <el-switch v-model="config.tool.show_check_lottery"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="4">                  
                <el-form-item label="显示用户" >
                  <el-switch v-model="config.tool.show_player"></el-switch> 
                </el-form-item> 
              </el-col>  
              <el-col :span="4">
                <el-form-item label="显示销售" >                               
                  <el-switch v-model="config.tool.show_salesman"></el-switch>
                </el-form-item> 
              </el-col>
              <el-col :span="4">
                <el-form-item label="显示留言" >                               
                  <el-switch v-model="config.tool.show_message"></el-switch>
                </el-form-item> 
              </el-col>
            </el-row>

            <el-form-item label="分享配置" >
              <el-row>
                <el-input size="medium" v-model="config.share.title" autosize placeholder="请填写分享标题">
                  <template slot="prepend">标题</template>
                </el-input>
              </el-row>
              <el-row>
                <el-input size="medium" v-model="config.share.desc" autosize placeholder="请填写分享内容">
                  <template slot="prepend">内容</template>
                </el-input>
              </el-row>
              <el-row>
                <el-input size="medium" v-model="config.share.icon" autosize placeholder="请填写分享图标地址">
                  <template slot="prepend">图标</template>
                </el-input>
              </el-row>
            </el-form-item>

            <el-form-item style="margin-bottom: 0px !important">              
              <el-button type="primary" style="float:right;" icon="el-icon-circle-plus-outline" round @click="handleAdd">添加</el-button>
            </el-form-item>
            <el-form-item label="用户数据" >
              <el-table
                :data="svr_config.xlsx"
                style="width: 100%">
                <el-table-column
                  label="参数名"
                  width="180">
                  <template slot-scope="scope">
                    <i class="el-icon-suitcase"></i>
                    <span v-if="editRowIndex!=scope.$index" style="margin-left: 10px">{{ scope.row.name }}</span>
                    <el-input v-model="scope.row.name" v-else style="margin-left: 10px">{{ scope.row.name }}</el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="变量名"
                  width="180">
                  <template slot-scope="scope">
                    <i class="el-icon-s-goods"></i>
                    <span v-if="editRowIndex!=scope.$index" style="margin-left: 10px">{{ scope.row.field }}</span>
                    <el-input v-model="scope.row.field" v-else style="margin-left: 10px">{{ scope.row.field }}</el-input>
                  </template>
                </el-table-column>                 
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>    

            <el-form-item class="submit">
              <el-button type="primary" @click="submitForm('form')">保 存</el-button>
              <el-button @click="resetForm('form')">重 置</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import projectApi from '../../models/project'
import Uploader from '../../../Common/components/file/uploader'
import { CheckUrl } from '../../../Common/validator'
import { cloneDeep } from 'lodash'

export default {
  components: {
    Uploader,
  },
  props: {
    dataID: {
      type: Number,
    },
  },
  data() {
    const validateTitle = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入项目名字'))
      }
      callback()
    }
    return {
      loading: false,
      form: {
        title: '',
        summary: '',
        image1: '',
        image2: '',
        url: '',
      },
      rules: {
        title: [
          { validator: validateTitle, trigger: 'blur', required: true },
        ],
      },      

      editRowIndex: -1,
      config: {
        share: {

        },
        tool: {

        }
      },
      svr_config: {    
        user_base_id: 0,
        user_id_skip: 0,     
        need_verify: true,
        xlsx: [],
      }
    }
  },
  methods: {
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            let xlsx = {names:[],fields:[]};
            for(let i in this.svr_config.xlsx) {
              let citem = this.svr_config.xlsx[i];
              xlsx.names.push(citem.name);
              xlsx.fields.push(citem.field);
            }
            let cfg = cloneDeep(this.svr_config)
            cfg.xlsx = xlsx
            if(this.svr_config.xlsx.length ==0) {
              delete cfg['xlsx']
            }
            this.form.svr_config = JSON.stringify(cfg)
            this.form.config = JSON.stringify(this.config);

            const res = await projectApi.edit(this.dataID, this.form)
            if (res.error_code === 0) {
              this.$message.success(`${res.msg}`)
              this.$emit('editClose')
            }
          } catch (error) {
            console.log(error)
          }
        } else {
          console.log('error submit!!')
          this.$message.error('请填写正确的信息')
          return false
        }
      })
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields()      
      this.$refs.logoUploader.reset()
    },
    back() {
      this.$emit('editClose')
    },

    handleAdd() {
      this.editRowIndex = -1;
      this.svr_config.xlsx.push({name: '姓名', field: 'name'});
    },
    handleEdit (index, row) {
      this.editRowIndex = index;
    },
    handleDelete (index, row) {
      this.svr_config.xlsx.splice(index, 1);
    },
  },
  async mounted() {
    this.loading = true
    this.form = await projectApi.get(this.dataID)    
    try {
      if(this.form.svr_config) {
        let json = JSON.parse(this.form.svr_config)
        let xlsx = []
        if(json.xlsx) {
          let xlsxConfig = json.xlsx
          for(let i=0;i<xlsxConfig.names.length;i++) {
            xlsx.push({
              name: xlsxConfig.names[i],
              field: xlsxConfig.fields[i],
            })
          }
        }
        json.xlsx = xlsx
        this.svr_config = json;    
      }

      if(this.form.config) {
        this.config = JSON.parse(this.form.config)   
        if(!this.config.tool) {
          this.config.tool = {}
        }
        if(!this.config.share) {
          this.config.share = {}
        }
      }   
    }catch{

    }

    this.loading = false
  },
}
</script>

<style lang="scss" scoped>
.container {
  .title {
    height: 59px;
    line-height: 59px;
    color: $parent-title-color;
    font-size: 16px;
    font-weight: 500;
    text-indent: 40px;
    border-bottom: 1px solid #dae1ec;

    .back {
      float: right;
      margin-right: 40px;
      cursor: pointer;
    }
  }

  .wrap {
    padding: 20px;
  }

  .submit {
    float: left;
  }
}
</style>
